import styled, { css, keyframes } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background: linear-gradient(90deg, #2E93EE 0%, #2E93EE 6.25%, #2F92ED 12.5%, #3091ED 18.75%, #3190EC 25%, #338EEB 31.25%, #358CE9 37.5%, #3789E8 43.75%, #3A86E6 50%, #3D83E4 56.25%, #417FE1 62.5%, #457BDF 68.75%, #4976DC 75%, #4E71D9 81.25%, #536CD5 87.5%, #5866D2 93.75%, #5E60CE 100%);
    border-radius: 16px;
    position: relative;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      border-radius: 0 0 16px 16px;
    }
  `}
`;

export const ConversationBox = styled.div`
  ${({ theme }) => css`
    border-radius: 16px 16px 14px 14px;
    padding: 40px 0;
    background-color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    overflow: hidden;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 24px 0;
      gap: 16px;
    }
  `}
`;

export const AiChatFormAdapter = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0 16px;
    }
  `}
`;
export const BouncingAnimation = keyframes`
  0% {
    margin-left: 40px;
  }
  10% {
    margin-left: -40px;
  }
  20% {
    margin-left: 40px;
  }
  100% {
    margin-left: 40px;
  }
`;

export const SuggestionsWrapper = styled.div`
  ${({ theme, $interacted }) => css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;
    max-width: 930px;
    width: 100%;
    padding: 0 24px;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0;
      padding-left: 56px;
      flex-direction: row;

      justify-content: flex-start !important;
      overflow: scroll;
      width: calc(100%);
      flex-wrap: nowrap;
      padding-right: 16px;

      &::-webkit-scrollbar {
        display: none;
      }
      scrollbar-width: none;
      -ms-overflow-style: none;

      ${!$interacted && css`
        animation: ${BouncingAnimation} 3s infinite;
      `}
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding-left: 16px;
    }
  `}
`;

export const GuideButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0px;
  position: absolute;
  right: 24px;
  top: 20px;
`;
